webpackJsonp([3],{

/***/ "2PDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/toastMethods.vue




/* harmony default export */ var toastMethods = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addToastAction']), {
    addToast: function addToast(type, content) {
      var data = {
        type: type,
        content: content
      };
      this.addToastAction(data);
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/toastMethods.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  toastMethods,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_toastMethods = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "598Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ls__);



var options = {
  namespace: 'goshrimp_'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_ls___default.a, options);

/***/ }),

/***/ "5xS/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "DBs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");



var config = {
  locale: 'zh',
  events: 'input',
  dictionary: {
    zh: {
      messages: {
        required: function required(field) {
          return field + ' 必填';
        },
        min: function min(field, args) {
          return field + ' 最少 ' + args + ' 個字';
        },
        max: function max(field, args) {
          return field + ' 不得超過 ' + args + ' 個字';
        },
        digits: function digits(field, args) {
          return field + ' 請輸入 ' + args + ' 位數字';
        },
        min_value: function min_value(field, args) {
          return field + ' 不得低於 ' + args;
        },
        max_value: function max_value(field, args) {
          return field + ' 不得超過 ' + args;
        },
        integer: function integer(field) {
          return field + ' 必須為整數';
        },
        mimes: function mimes(field, args) {
          return field + ' 必須符合MIME類型 ' + args;
        },
        ext: function ext(field, args) {
          return field + ' 必須符合檔案類型 ' + args;
        },
        dimensions: function dimensions(field, args) {
          return field + ' 寬與高須分別為 ' + args;
        },
        regex: function regex(field) {
          return '格式有誤 ' + field;
        },
        email: function email(field) {
          return field + ' 請輸入正確Email格式';
        },
        confirmed: function confirmed() {
          return '密碼不相符';
        },
        youtubeLink: function youtubeLink(field) {
          return field + ' 不是youtube內嵌影片連結格式';
        }
      },
      attributes: {
        account: '帳號',
        password: '密碼'
      }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */], config);

/***/ }),

/***/ "E4co":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/responsitive.vue

/* harmony default export */ var responsitive = ({
  data: function data() {
    return {
      windowWidth: 0,
      windowHeight: 0
    };
  },

  computed: {
    isMobile: function isMobile() {
      return this.windowWidth <= 499.9;
    }
  },
  created: function created() {
    var _this = this;

    var handler = function handler() {
      _this.windowWidth = window.innerWidth;
      _this.windowHeight = window.innerHeight;
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
    window.dispatchEvent(new Event('resize'));
  }
});
// CONCATENATED MODULE: ./src/mixins/responsitive.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  responsitive,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_responsitive = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F7NO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.ae373e2.gif";

/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "GpfI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "MEzR":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS41IiBoZWlnaHQ9IjE1LjUiIHZpZXdCb3g9IjAgMCAxNS41IDE1LjUiPgogIDxnIGlkPSLjgrDjg6vjg7zjg5dfMTY3MiIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgMTY3MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYxMi4xMjUgLTQ2LjIwNykiPgogICAgPGcgaWQ9IuOCsOODq+ODvOODl18xIiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MTYuNCA0Ny45NzYpIj4KICAgICAgPHBhdGggaWQ9IuODkeOCuV8xIiBkYXRhLW5hbWU9IuODkeOCuSAxIiBkPSJNNjQ1Ljk3OSw1Ny44NjgsNjQyLjYxLDY5LjAxMmE0Ljg3OCw0Ljg3OCwwLDAsMSwzLjUyNS0yLjA2YzIuMDQ2LDAsMy43ODksMi4wNiwzLjc4OSwyLjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY0Mi42MSAtNTcuODY4KSIgZmlsbD0iI2ZmZiIvPgogICAgPC9nPgogICAgPHBhdGggaWQ9IuODkeOCuV8yIiBkYXRhLW5hbWU9IuODkeOCuSAyIiBkPSJNNjI3LjM3NSw1My45NTdhNy41LDcuNSwwLDEsMS03LjUtNy41QTcuNSw3LjUsMCwwLDEsNjI3LjM3NSw1My45NTdabS03LjUtNy4wODhhNy4wODgsNy4wODgsMCwxLDAsNy4wODgsNy4wODhBNy4wODgsNy4wODgsMCwwLDAsNjE5Ljg3NSw0Ni44N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjAuNSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__("gyMJ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/nullConditionalOperator.vue

/* harmony default export */ var nullConditionalOperator = ({
  methods: {
    nco: function nco(operation, _default) {
      try {
        var result = operation();
        return result !== null && result !== undefined ? result : _default;
      } catch (e) {
        return _default;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/nullConditionalOperator.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  nullConditionalOperator,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_nullConditionalOperator = (Component.exports);

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/mixins/responsitive.vue + 1 modules
var responsitive = __webpack_require__("E4co");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/loginData.vue




/* harmony default export */ var loginData = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserAction', 'setLoginAction', 'setUserInfoAction']), {
    setUserData: function setUserData(response) {
      this.setUserAction(response ? response.data.user || response.data.data : null);
      this.setLoginAction(!!response);
      this.setUserInfo(response ? response.headers : null);
    },
    setUserInfo: function setUserInfo(headers) {
      if (headers && headers.uid) {
        var expiry = headers.expiry * 1000;
        var info = {
          uid: headers.uid,
          client: headers.client,
          'access-token': headers['access-token'],
          'content-type': 'application/json'
        };
        this.setUserInfoAction(info);
        this.$ls.set('userInfo', info, expiry);
      } else {
        this.setUserInfoAction(null);
        this.$ls.remove('userInfo');
      }
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/loginData.vue
var loginData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var loginData___vue_template__ = null
/* template functional */
var loginData___vue_template_functional__ = false
/* styles */
var loginData___vue_styles__ = null
/* scopeId */
var loginData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loginData___vue_module_identifier__ = null
var loginData_Component = loginData_normalizeComponent(
  loginData,
  loginData___vue_template__,
  loginData___vue_template_functional__,
  loginData___vue_styles__,
  loginData___vue_scopeId__,
  loginData___vue_module_identifier__
)

/* harmony default export */ var mixins_loginData = (loginData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/header.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var header = ({
  mixins: [mixins_nullConditionalOperator, toastMethods["a" /* default */], responsitive["a" /* default */], mixins_loginData],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isLogin', 'user']), {
    // static data
    functionMenu: function functionMenu() {
      var _this = this;

      return [{
        title: '首頁',
        icon: 'fa-fw fa-file',
        linkTo: { name: 'main' }
      }, {
        title: 'Index',
        icon: 'fa-fw fa-file',
        linkTo: { name: 'index' }
      }].filter(function (x) {
        return (x.isLogin === undefined || x.isLogin === _this.isLogin) && (x.admin === undefined || x.admin === _this.user.admin);
      });
    },
    userMenu: function userMenu() {
      var _this2 = this;

      return [{
        title: '登入',
        icon: 'fa-fw fa-sign-in',
        isLogin: false
      }, {
        title: '登出',
        icon: 'fa-fw fa-sign-out',
        isLogin: true
      }].filter(function (x) {
        return (x.isLogin === undefined || x.isLogin === _this2.isLogin) && (x.admin === undefined || x.admin === _this2.user.admin);
      });
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    menuButton: function menuButton(type, menu) {
      if (type === 'function') {
        switch (menu.title) {
          default:
            {}
        }
      } else if (type === 'user') {
        switch (menu.title) {
          case '登入':
            {
              this.loginClick();
              break;
            }
          case '登出':
            {
              this.logoutClick();
              break;
            }
          default:
            {}
        }
      }
    },
    loginClick: function loginClick() {
      this.setModalAction({
        action: 'login',
        width: '300px',
        param: {
          route: extends_default()({}, this.$route)
        }
      });
    },
    logoutClick: function logoutClick() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this3.$ls.get('userInfo');
                _context.next = 4;
                return Object(api["a" /* deleteUser */])(config);

              case 4:
                _this3.setUserData(null);
                _this3.$router.push({ name: 'main' });
                _this3.addToast('success', '登出成功');
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this3.setLoginAction(true);
                _this3.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.errors[0]);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 9]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4132b8a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"max-width row-block"},[_c('div',{staticClass:"left"},[(_vm.functionMenu.length)?_c('div',{staticClass:"function-col"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"function-menu"},[_c('ul',_vm._l((_vm.functionMenu),function(menu,index){return _c('li',{key:index},[_c('hr'),_vm._v(" "),(menu.linkTo)?_c('router-link',{staticClass:"button",attrs:{"to":menu.linkTo}},[(menu.icon)?_c('i',{staticClass:"fa",class:menu.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(menu.title))])]):_c('button',{staticClass:"button",on:{"click":function($event){_vm.menuButton('function', menu)}}},[(menu.icon)?_c('i',{staticClass:"fa",class:menu.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(menu.title))])])],1)}),0)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'main' }}},[_c('span',[_vm._v("Global Title")])])],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"user-col"},[_c('button',{staticClass:"user-button"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.isLogin ? _vm.user.username : 'User Menu'))]),_vm._v(" "),_c('div',{staticClass:"icon-field"},[_c('div',{staticClass:"images",class:{ 'login': _vm.isLogin }},[(_vm.nco(function () { return _vm.user.avatar_url.length > 0; }, null))?_c('img',{attrs:{"src":_vm.user.avatar_url}}):_c('span',[_vm._v(_vm._s(_vm.nco(function () { return _vm.user.realname ? _vm.user.realname[0].toUpperCase() : _vm.user.username[0].toUpperCase(); }, '')))])])])]),_vm._v(" "),_c('div',{staticClass:"user-menu"},[_c('div',{staticClass:"menu-block"},[_c('ul',_vm._l((_vm.userMenu),function(menu,index){return _c('li',{key:index},[_c('hr'),_vm._v(" "),(menu.linkTo)?_c('router-link',{staticClass:"button",attrs:{"to":menu.linkTo}},[(menu.icon)?_c('i',{staticClass:"fa",class:menu.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(menu.title))])]):_c('button',{staticClass:"button",on:{"click":function($event){_vm.menuButton('user', menu)}}},[(menu.icon)?_c('i',{staticClass:"fa",class:menu.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(menu.title))])])],1)}),0)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"function-button"},[_c('i',{staticClass:"fa fa-bars icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Function Menu")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_header = (esExports);
// CONCATENATED MODULE: ./src/components/layout/header.vue
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = null
/* scopeId */
var header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  layout_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var components_layout_header = (header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/invisible.vue
//
//
//
//

/* harmony default export */ var invisible = ({
  props: {
    size: {
      type: Number,
      required: true
    },
    isFullWidth: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42affba1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/invisible.vue
var invisible_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"color":"transparent","userSelect":"none"}},[_vm._v(_vm._s((new Array(_vm.size)).fill(_vm.isFullWidth ? '＿' : '_', 0).join('')))])}
var invisible_staticRenderFns = []
var invisible_esExports = { render: invisible_render, staticRenderFns: invisible_staticRenderFns }
/* harmony default export */ var tool_invisible = (invisible_esExports);
// CONCATENATED MODULE: ./src/components/tool/invisible.vue
var invisible_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var invisible___vue_template_functional__ = false
/* styles */
var invisible___vue_styles__ = null
/* scopeId */
var invisible___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var invisible___vue_module_identifier__ = null
var invisible_Component = invisible_normalizeComponent(
  invisible,
  tool_invisible,
  invisible___vue_template_functional__,
  invisible___vue_styles__,
  invisible___vue_scopeId__,
  invisible___vue_module_identifier__
)

/* harmony default export */ var components_tool_invisible = (invisible_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/footer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var footer = ({
  components: {
    invisible: components_tool_invisible
  },
  mixins: [responsitive["a" /* default */]]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ebfacb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"max-width col-block"},[_c('div',{staticClass:"content",class:{ 'col-block': _vm.windowWidth < 1199.9 }},[_c('div',[_c('a',{attrs:{"href":"https://www.compassbioinfo.com","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("MEzR")}}),_vm._v(" "),_c('span',[_vm._v("康百事生物資訊股份有限公司")])]),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_vm._m(5)])])}
var footer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.linkedin.com/company/compass-bioinformatics","target":"_blank"}},[_c('i',{staticClass:"fa fa-linkedin-square fa-fw",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.facebook.com/compassbioinfo","target":"_blank"}},[_c('i',{staticClass:"fa fa-facebook-official fa-fw",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"tel:886-3-5745009"}},[_c('i',{staticClass:"fa fa-phone fa-flip-horizontal fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v("+886-3-574-5009")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.google.com/maps/search/?api=1&query=新竹市東區慈雲路118號17樓之10","target":"_blank"}},[_c('i',{staticClass:"fa fa-map-marker fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v("新竹市東區慈雲路118號17樓之10")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"mailto:service@compassbioinfo.com"}},[_c('i',{staticClass:"fa fa-envelope fa-fw",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',[_vm._v("service@compassbioinfo.com")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',[_vm._v("Copyright © 2019 Compass Bioinformatics")])])}]
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var layout_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/layout/footer.vue
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  layout_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_layout_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/toast.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  computed: Object(vuex_esm["c" /* mapGetters */])(['messages']),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['deleteToastAction']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b481162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/toast.vue
var toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-position"},[_c('div',{staticClass:"toast-container"},[_c('transition-group',{attrs:{"name":"toastDown"}},_vm._l((_vm.messages),function(msg,index){return _c('div',{key:index + 0,staticClass:"toast"},[_c('div',{staticClass:"option"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"},on:{"click":function (e) { return _vm.deleteToastAction(index); }}})]),_vm._v(" "),_c('div',{staticClass:"line",class:[msg.type]}),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(msg.content)}})])}),0)],1)])}
var toast_staticRenderFns = []
var toast_esExports = { render: toast_render, staticRenderFns: toast_staticRenderFns }
/* harmony default export */ var tool_toast = (toast_esExports);
// CONCATENATED MODULE: ./src/components/tool/toast.vue
var toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toast___vue_template_functional__ = false
/* styles */
var toast___vue_styles__ = null
/* scopeId */
var toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toast___vue_module_identifier__ = null
var toast_Component = toast_normalizeComponent(
  toast,
  tool_toast,
  toast___vue_template_functional__,
  toast___vue_styles__,
  toast___vue_scopeId__,
  toast___vue_module_identifier__
)

/* harmony default export */ var components_tool_toast = (toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a07f2c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/loading.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("F7NO"),"alt":""}})])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var layout_loading = (loading_esExports);
// CONCATENATED MODULE: ./src/components/layout/loading.vue
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = null
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  layout_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)

/* harmony default export */ var components_layout_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/uploading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var uploading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aafb3b24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/uploading.vue
var uploading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploading-page"},[_c('div',{staticClass:"img-box"},[_c('h1',[_vm._v("檔案上傳中")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var uploading_staticRenderFns = []
var uploading_esExports = { render: uploading_render, staticRenderFns: uploading_staticRenderFns }
/* harmony default export */ var layout_uploading = (uploading_esExports);
// CONCATENATED MODULE: ./src/components/layout/uploading.vue
var uploading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var uploading___vue_template_functional__ = false
/* styles */
var uploading___vue_styles__ = null
/* scopeId */
var uploading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var uploading___vue_module_identifier__ = null
var uploading_Component = uploading_normalizeComponent(
  uploading,
  layout_uploading,
  uploading___vue_template_functional__,
  uploading___vue_styles__,
  uploading___vue_scopeId__,
  uploading___vue_module_identifier__
)

/* harmony default export */ var components_layout_uploading = (uploading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7054e329","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/loading.vue
var dialog_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-dialog"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("F7NO"),"alt":""}})])])}
var dialog_loading_staticRenderFns = []
var dialog_loading_esExports = { render: dialog_loading_render, staticRenderFns: dialog_loading_staticRenderFns }
/* harmony default export */ var components_dialog_loading = (dialog_loading_esExports);
// CONCATENATED MODULE: ./src/components/dialog/loading.vue
var dialog_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_loading___vue_template_functional__ = false
/* styles */
var dialog_loading___vue_styles__ = null
/* scopeId */
var dialog_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_loading___vue_module_identifier__ = null
var dialog_loading_Component = dialog_loading_normalizeComponent(
  dialog_loading,
  components_dialog_loading,
  dialog_loading___vue_template_functional__,
  dialog_loading___vue_styles__,
  dialog_loading___vue_scopeId__,
  dialog_loading___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_loading = (dialog_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/container.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var container = ({
  components: {
    dialogLoading: src_components_dialog_loading
  },
  props: {
    width: {
      type: String,
      default: function _default() {
        return '400px';
      }
    },
    height: {
      type: String,
      default: function _default() {
        return 'auto';
      }
    },
    customStyles: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isDialogLoading']), {
    containerStyle: function containerStyle() {
      return extends_default()({}, this.customStyles, { height: this.height, width: this.width });
    }
  }),
  methods: {
    closeModal: function closeModal(e) {
      if (!['modal-mask', 'modal-wrapper'].includes(e.target.className)) {
        return;
      }
      this.$emit('hide');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d805e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/container.vue
var container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",style:(_vm.containerStyle)},[_vm._t("default"),_vm._v(" "),(_vm.isDialogLoading)?_c('dialogLoading'):_vm._e()],2)])])])}
var container_staticRenderFns = []
var container_esExports = { render: container_render, staticRenderFns: container_staticRenderFns }
/* harmony default export */ var dialog_container = (container_esExports);
// CONCATENATED MODULE: ./src/components/dialog/container.vue
function injectStyle (ssrContext) {
  __webpack_require__("GpfI")
}
var container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var container___vue_template_functional__ = false
/* styles */
var container___vue_styles__ = injectStyle
/* scopeId */
var container___vue_scopeId__ = "data-v-55d805e5"
/* moduleIdentifier (server only) */
var container___vue_module_identifier__ = null
var container_Component = container_normalizeComponent(
  container,
  dialog_container,
  container___vue_template_functional__,
  container___vue_styles__,
  container___vue_scopeId__,
  container___vue_module_identifier__
)

/* harmony default export */ var components_dialog_container = (container_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/order.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var order = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    methodOptions: function methodOptions() {
      return [{ title: '信用卡', value: 'credit' }, { title: '實體ATM', value: 'atm' }, { title: '網路ATM', value: 'eatm' }];
    },
    displayOptions: function displayOptions() {
      var _this = this;

      return [
      // {
      //   title: '所在地區',
      //   value: order => order ? order.country : ''
      // },
      {
        title: '受檢者姓名',
        value: function value(order) {
          return order ? order.subject_name : '';
        }
      },
      // {
      //   title: '身分證字號或護照號碼',
      //   value: order => order ? order.id_number : ''
      // },
      // {
      //   title: '出生日期',
      //   value: order => order ? order.birthday : ''
      // },
      {
        title: '性別',
        value: function value(order) {
          return order ? order.gender : '';
        }
      }, {
        title: '電子郵件',
        value: function value(order) {
          return order ? order.email : '';
        }
      }, {
        title: '聯絡人',
        value: function value(order) {
          return order ? order.contact_name : '';
        }
      }, {
        title: '行動電話',
        value: function value(order) {
          return order ? order.phone : '';
        }
      },
      // {
      //   title: '居住縣市',
      //   value: order => order ? order.city : ''
      // },
      // {
      //   title: '醫生姓名(所在醫院)',
      //   value: order => order ? order.doctor_user.name + '(' + order.doctor_user.doctor_profile.hospital_name + ')' : ''
      // },
      {
        title: '產品選擇',
        value: function value(order) {
          return order ? order.product.display : '';
        }
      }, {
        title: '付款方式',
        value: function value(order) {
          return order ? (_this.methodOptions.find(function (option) {
            return option.value === order.payment_method;
          }) || {}).title : '';
        }
      }, {
        title: '分期',
        value: function value(order) {
          return order ? order.ecpay_credit_divide === 0 ? '不分期' : '分' + order.ecpay_credit_divide + '期' : '';
        },
        display: function display(order) {
          return ['credit'].includes(order.payment_method);
        }
      }, {
        title: '父親姓名',
        value: function value(order) {
          return order ? order.father_subject_name : '';
        },
        display: function display(order) {
          return order && [3, 4].includes(order.product.subject_number);
        }
      }, {
        title: '父親身分證字號或護照號碼',
        value: function value(order) {
          return order ? order.father_id_number : '';
        },
        display: function display(order) {
          return order && [3, 4].includes(order.product.subject_number);
        }
      }, {
        title: '父親出生日期',
        value: function value(order) {
          return order ? order.father_birthday : '';
        },
        display: function display(order) {
          return order && [3, 4].includes(order.product.subject_number);
        }
      }, {
        title: '母親姓名',
        value: function value(order) {
          return order ? order.mother_subject_name : '';
        },
        display: function display(order) {
          return order && [3, 4].includes(order.product.subject_number);
        }
      }, {
        title: '母親身分證字號或護照號碼',
        value: function value(order) {
          return order ? order.mother_id_number : '';
        },
        display: function display(order) {
          return order && [3, 4].includes(order.product.subject_number);
        }
      }, {
        title: '母親出生日期',
        value: function value(order) {
          return order ? order.mother_birthday : '';
        },
        display: function display(order) {
          return order && [3, 4].includes(order.product.subject_number);
        }
      }, {
        title: '受檢者2姓名',
        value: function value(order) {
          return order ? order.subject_2_name : '';
        },
        display: function display(order) {
          return order && [4].includes(order.product.subject_number);
        }
      }, {
        title: '受檢者2身分證字號或護照號碼',
        value: function value(order) {
          return order ? order.subject_2_id_number : '';
        },
        display: function display(order) {
          return order && [4].includes(order.product.subject_number);
        }
      }, {
        title: '受檢者2出生日期',
        value: function value(order) {
          return order ? order.subject_2_birthday : '';
        },
        display: function display(order) {
          return order && [4].includes(order.product.subject_number);
        }
      }, {
        title: '受檢者2性別',
        value: function value(order) {
          return order ? order.subject_2_gender : '';
        },
        display: function display(order) {
          return order && [4].includes(order.product.subject_number);
        }
      }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-276c92af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/order.vue
var order_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-dailog col-block"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"data-container col-block",style:({ flex: 1 })},[_vm._l((_vm.displayOptions.filter(function (option) { return (option.display || (function () { return true; }))(_vm.param.order); })),function(option,index){return _c('div',{key:index,staticClass:"data-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(option.value(_vm.param.order)))])])}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('button',{staticClass:"main-button",on:{"click":function($event){_vm.$emit('changeModal', {}, true)}}},[_c('span',[_vm._v("付款")])]),_vm._v(" "),_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('button',{staticClass:"white-button",on:{"click":function($event){_vm.$emit('changeModal', {})}}},[_c('span',[_vm._v("返回")])])])])}
var order_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v("訂單預覽")])])}]
var order_esExports = { render: order_render, staticRenderFns: order_staticRenderFns }
/* harmony default export */ var dialog_order = (order_esExports);
// CONCATENATED MODULE: ./src/components/dialog/order.vue
var order_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var order___vue_template_functional__ = false
/* styles */
var order___vue_styles__ = null
/* scopeId */
var order___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var order___vue_module_identifier__ = null
var order_Component = order_normalizeComponent(
  order,
  dialog_order,
  order___vue_template_functional__,
  order___vue_styles__,
  order___vue_scopeId__,
  order___vue_module_identifier__
)

/* harmony default export */ var components_dialog_order = (order_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/toast.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_toast = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25caf9a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/toast.vue
var dialog_toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-toast"},[_c('div',{staticClass:"line",class:[_vm.param.type]}),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.param.content)}}),_vm._v(" "),_c('div',{staticClass:"button-row"},_vm._l((_vm.param.buttons || []),function(button,index){return _c('button',{key:index,staticClass:"long-button",class:[button.type + '-button'],on:{"click":function($event){_vm.$emit('changeModal', {}, button.result)}}},[_c('span',[_vm._v(_vm._s(button.title))])])}),0)])}
var dialog_toast_staticRenderFns = []
var dialog_toast_esExports = { render: dialog_toast_render, staticRenderFns: dialog_toast_staticRenderFns }
/* harmony default export */ var components_dialog_toast = (dialog_toast_esExports);
// CONCATENATED MODULE: ./src/components/dialog/toast.vue
var dialog_toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_toast___vue_template_functional__ = false
/* styles */
var dialog_toast___vue_styles__ = null
/* scopeId */
var dialog_toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_toast___vue_module_identifier__ = null
var dialog_toast_Component = dialog_toast_normalizeComponent(
  dialog_toast,
  components_dialog_toast,
  dialog_toast___vue_template_functional__,
  dialog_toast___vue_styles__,
  dialog_toast___vue_scopeId__,
  dialog_toast___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_toast = (dialog_toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// modals




__webpack_require__("5W8o");

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    layoutHeader: components_layout_header,
    layoutFooter: components_layout_footer,
    layoutToast: components_tool_toast,
    layoutLoading: components_layout_loading,
    layoutUploading: components_layout_uploading,
    // modals
    modal: components_dialog_container,
    order: components_dialog_order,
    toast: src_components_dialog_toast
  },
  mixins: [responsitive["a" /* default */], mixins_loginData, toastMethods["a" /* default */]],
  data: function data() {
    return {
      userAgent: '',
      minHeight: '300px'
    };
  },

  watch: {
    '$route': function $route() {
      var _document = document,
          body = _document.body;

      body.scroll(0, 0);
      setTimeout(function () {
        return window.dispatchEvent(new Event('resize'));
      });
    },
    'isLogin': function isLogin(n, o) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(o !== null)) {
                  _context.next = 9;
                  break;
                }

                _this.setLoadingAction(true);
                _context.next = 4;
                return _this.preFetchDataGuest();

              case 4:
                if (!n) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return _this.preFetchData();

              case 7:
                _this.appInitialAction(n);
                _this.setLoadingAction(false);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['normalPage', 'userPage', 'isLogin', 'isLoading', 'isDialogLoading', 'isUploading', 'modal']), {
    isMainPage: function isMainPage() {
      return this.$route.name && ['main', 'payment', ''].includes(this.$route.name);
    }
  }),
  created: function created() {
    var _this2 = this;

    this.userAgent = navigator.userAgent;
    this.setModalAction({});
    this.setLoadingAction(true);
    var validateLogin = function validateLogin() {
      if (_this2.$route.name) {
        _this2.validateLogin();
      } else {
        setTimeout(function () {
          return validateLogin();
        }, 100);
      }
    };
    validateLogin();
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    var _document2 = document,
        body = _document2.body;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var headerHeight = 0;
        var footerHeight = !(_this3.windowWidth < 1199.9) ? 140 : 170;
        if (_this3.$route.name === 'payment') {
          footerHeight = 0;
        }
        var height = rect.height - headerHeight - footerHeight;
        _this3.minHeight = height + 'px';
      }
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['appInitialAction', 'setLoadingAction', 'setDialogLoadingAction', 'clearLoadingAction', 'clearDialogLoadingAction', 'setModalAction'
  // global
  ]), {
    preFetchDataGuest: function preFetchDataGuest() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    preFetchData: function preFetchData() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    validateLogin: function validateLogin() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var userInfo;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userInfo = _this6.$ls.get('userInfo') || {};
                _context4.next = 3;
                return _this6.preFetchDataGuest();

              case 3:
                if (!userInfo['access-token']) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 6;
                return _this6.preFetchData();

              case 6:
                _context4.next = 8;
                return _this6.getUserByToken(userInfo);

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _this6.setUserData(null);
                _this6.appInitialAction(false);
                _this6.validateRoute(false);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    getUserByToken: function getUserByToken(data) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var response, user;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return Object(api["f" /* getUserToken */])(data);

              case 3:
                response = _context5.sent;
                user = response.data.user || { role: {} };

                _this7.setUserData(response);
                _this7.appInitialAction(true);
                _this7.validateRoute(true, user.role.name, user.admin);
                _context5.next = 16;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);

                _this7.setUserData(null);
                _this7.appInitialAction(true);
                _this7.addToast('error', !_context5.t0.response ? _context5.t0.message : _context5.t0.response.data.errors[0]);
                _this7.validateRoute(false);

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 10]]);
      }))();
    },
    validateRoute: function validateRoute(isLogin, role, admin) {
      var array = [];
      if (isLogin) {
        switch (role) {
          default:
            {
              array = lodash_default.a.union(this.userPage, this.normalPage);
            }
        }
      } else {
        array = this.normalPage;
      }
      if (admin) {
        array = lodash_default.a.union(array, this.adminPage);
      }
      this.validateRole(isLogin, array);
    },
    validateRole: function validateRole(isLogin, pages) {
      var routeName = this.$route.name;
      if (routeName && !lodash_default.a.includes(pages, routeName)) {
        this.addToast('error', isLogin ? '權限不足' : '請先登入');
        this.$router.push({ name: 'main' });
        this.setLoadingAction(false);
      } else {
        this.setLoadingAction(false);
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a9124a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-root",class:{ 'mac-os': _vm.userAgent.includes('Mac') },attrs:{"id":"app"}},[_c('div',{staticClass:"app-container",style:({ position: _vm.modal.action && !_vm.isDialogLoading ? 'relative' : 'relative' })},[_c('div',{staticClass:"app-pages"},[_c('div',{staticClass:"app-background",class:{ filter: !_vm.isMainPage, cover: _vm.isMainPage },style:({ background: '#eeeeee', backgroundSize: 'cover' })}),_vm._v(" "),(!_vm.isMainPage)?_c('div',{staticClass:"max-width",style:({ minHeight: _vm.minHeight, display: _vm.isMainPage ? 'flex' : 'block', 'align-items': 'center' })},[_c('div',{staticClass:"view-container"},[_c('div',{staticClass:"view-field responsitive-color white-white"},[_c('router-view')],1)])]):_c('div',{staticClass:"app-main-container"},[_c('router-view',{attrs:{"minHeight":_vm.minHeight}})],1),_vm._v(" "),(_vm.$route.name && !['payment'].includes(_vm.$route.name))?_c('layout-footer'):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"modal-container"},[(_vm.modal.action)?_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"width":_vm.modal.width,"height":_vm.modal.height,"customStyles":_vm.modal.customStyles},on:{"hide":function () {
      _vm.modal.callback && _vm.modal.callback()
      _vm.setModalAction({})
    }}},[_c(_vm.modal.action,{tag:"component",attrs:{"param":_vm.modal.param},on:{"changeModal":function (option, param) {
        _vm.modal.callback && _vm.modal.callback(param)
        this$1.setModalAction(option || {})
      }}})],1):_vm._e()],1),_vm._v(" "),_c('layout-toast'),_vm._v(" "),(_vm.isLoading)?_c('layoutLoading'):_vm._e(),_vm._v(" "),(_vm.isUploading)?_c('layoutUploading'):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("rnqg")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'root',
    redirect: { name: 'main' }
  }, {
    path: '/main',
    name: 'main',
    redirect: { name: 'index' }
  }, {
    path: '/payment/:type/:method/:token',
    name: 'payment',
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("G5mq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/index',
    name: 'index',
    component: function component(resolve) {
      __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2NXm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '*',
    redirect: { name: 'main' }
  }]
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/modules/app.js


var _mutations;

var app_state = {
  initial: null,
  isLogin: null,
  isLoading: [],
  isDialogLoading: [],
  isUploading: [],
  modal: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  messages: [],
  // const
  normalPage: ['main', 'payment', 'introduction', 'index'],
  userPage: [],
  adminPage: []
};

var getters = {
  initial: function initial(state) {
    return state.initial;
  },
  isLogin: function isLogin(state) {
    return state.isLogin;
  },
  isLoading: function isLoading(state) {
    return state.isLoading.length > 0;
  },
  isDialogLoading: function isDialogLoading(state) {
    return state.isDialogLoading.length > 0;
  },
  isUploading: function isUploading(state) {
    return state.isUploading.length > 0;
  },
  modal: function modal(state) {
    return state.modal;
  },
  messages: function messages(state) {
    return state.messages;
  },
  // const
  normalPage: function normalPage(state) {
    return state.normalPage;
  },
  userPage: function userPage(state) {
    return state.userPage;
  },
  adminPage: function adminPage(state) {
    return state.adminPage;
  }
};

var types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setModal: 'app/setModal',
  addToast: 'app/addToast',
  deleteToast: 'app/deleteToast'
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, types.appInitial, function (state, boolean) {
  state.initial = boolean;
}), defineProperty_default()(_mutations, types.setLogin, function (state, boolean) {
  state.isLogin = boolean;
}), defineProperty_default()(_mutations, types.setLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isLoading.push('');
    } else {
      state.isLoading.pop();
    }
  }
}), defineProperty_default()(_mutations, types.clearLoading, function (state) {
  state.isLoading = [];
}), defineProperty_default()(_mutations, types.setDialogLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isDialogLoading.push('');
    } else {
      state.isDialogLoading.pop();
    }
  }
}), defineProperty_default()(_mutations, types.clearDialogLoading, function (state) {
  state.isDialogLoading = [];
}), defineProperty_default()(_mutations, types.setUploading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isUploading.push('');
    } else {
      state.isUploading.pop();
    }
  }
}), defineProperty_default()(_mutations, types.setModal, function (state, object) {
  state.modal = object;
}), defineProperty_default()(_mutations, types.addToast, function (state, object) {
  state.messages.push(object);
  setTimeout(function () {
    state.messages.splice(0, 1);
  }, 5000);
}), defineProperty_default()(_mutations, types.deleteToast, function (state, index) {
  state.messages.splice(index, 1);
}), _mutations);

var actions = {
  appInitialAction: function appInitialAction(_ref, boolean) {
    var commit = _ref.commit;

    commit(types.appInitial, boolean);
  },
  setLoginAction: function setLoginAction(_ref2, boolean) {
    var commit = _ref2.commit;

    commit(types.setLogin, boolean);
  },
  setLoadingAction: function setLoadingAction(_ref3, boolean) {
    var commit = _ref3.commit;

    commit(types.setLoading, boolean);
  },
  clearLoadingAction: function clearLoadingAction(_ref4) {
    var commit = _ref4.commit;

    commit(types.clearLoading);
  },
  setDialogLoadingAction: function setDialogLoadingAction(_ref5, boolean) {
    var commit = _ref5.commit;

    commit(types.setDialogLoading, boolean);
  },
  clearDialogLoadingAction: function clearDialogLoadingAction(_ref6) {
    var commit = _ref6.commit;

    commit(types.clearDialogLoading);
  },
  setUploadingAction: function setUploadingAction(_ref7, boolean) {
    var commit = _ref7.commit;

    commit(types.setUploading, boolean);
  },
  setModalAction: function setModalAction(_ref8, string) {
    var commit = _ref8.commit;

    commit(types.setModal, string);
  },
  addToastAction: function addToastAction(_ref9, object) {
    var commit = _ref9.commit;

    commit(types.addToast, object);
  },
  deleteToastAction: function deleteToastAction(_ref10, index) {
    var commit = _ref10.commit;

    commit(types.deleteToast, index);
  }
};

/* harmony default export */ var app = ({
  state: app_state,
  getters: getters,
  mutations: mutations,
  actions: actions
});
// CONCATENATED MODULE: ./src/store/modules/global.js
var global_state = {};

var global_getters = {};

// const types = {
// }

var global_mutations = {};

var global_actions = {};

/* harmony default export */ var global = ({
  state: global_state,
  getters: global_getters,
  mutations: global_mutations,
  actions: global_actions
});
// CONCATENATED MODULE: ./src/store/modules/user.js



var user__mutations;

var user_state = {
  data: null,
  info: null
};

var user_getters = {
  user: function user(state) {
    return state.data ? extends_default()({}, state.data) : state.data;
  },
  userInfo: function userInfo(state) {
    return state.info ? extends_default()({}, state.info) : state.info;
  }
};

var user_types = {
  setUser: 'user/setUser',
  setUserInfo: 'user/setUserInfo'
};

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, user_types.setUser, function (state, object) {
  state.data = object;
}), defineProperty_default()(user__mutations, user_types.setUserInfo, function (state, object) {
  state.info = object;
}), user__mutations);

var user_actions = {
  setUserAction: function setUserAction(_ref, object) {
    var commit = _ref.commit;

    commit(user_types.setUser, object);
  },
  setUserInfoAction: function setUserInfoAction(_ref2, object) {
    var commit = _ref2.commit;

    commit(user_types.setUserInfo, object);
  }
};

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  mutations: user_mutations,
  actions: user_actions
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    app: app,
    global: global,
    user: modules_user
  }
}));
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






vee_validate_esm["a" /* Validator */].extend('youtubeLink', {
  getMessage: function getMessage() {
    return '';
  },
  validate: function validate(value) {
    return (/(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
    );
  }
});

__webpack_require__("DBs5");
__webpack_require__("598Q");

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "T452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ROOT; });
var TYPE = 'release';
var API_ROOT = {
  debug: 'https://api-dev.drlin.compassbioinfo.com/',
  release: 'https://server.gvss-inherinext.compassbioinfo.com/'
}[TYPE];

/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCitys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDivisions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDoctors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserToken; });
/* unused harmony export postUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return postOrder; });
/* unused harmony export getPaymentPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("T452");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

// global
var getCitys = function getCitys(config) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'ac/cities', { params: config });
};
var getDivisions = function getDivisions(config) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'ac/divisions', { params: config });
};
var getDoctors = function getDoctors(config) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'ac/doctors', { params: config });
};
var getProducts = function getProducts(config) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'ac/products', { params: config });
};
// user
var getUserToken = function getUserToken(config) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'users/current_user', { params: config });
};
var postUser = function postUser(data) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'users/sign_in', data);
};
var deleteUser = function deleteUser(config) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'users/sign_out', { params: config });
};
// order
var postOrder = function postOrder(data, config) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'orders', data, { params: config });
};
var getPaymentPage = function getPaymentPage(token, config) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* API_ROOT */] + 'orders/' + token + '/payment', { params: config });
};

/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "rnqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c6bee031c71cd6d9ec7b.js